import { createStore } from 'vuex'
import {scrollModule} from "@/store/scroll";

export default createStore({
  state: {
    isActiveModal: false,

    $isHistoryScreen: false,
    $isScrollParent: false,
    $activeFixedHeader: false,
    $isActiveHeaderTransition: false,
    $activeBlock: 'start-screen-container',
    $isMobile: false,
    $activeWhiteBlock: false,
    isBlockScroll: false,
  },
  getters: {
  },
  mutations: {
    SET_IS_ACTIVE_MODAL: (state, payload) => {
      console.log(payload)
      state.isActiveModal = payload
    },

    SET_IS_SCROLL_PARENT: (state, payload) => {
      state.$isScrollParent = payload
    },
    SET_IS_MOBILE: (state, payload) => {
      state.$isMobile = payload
    },
    SET_ACTIVE_FIXED_HEADER: (state, payload) => {
      state.$activeFixedHeader = payload
    },
    SET_IS_ACTIVE_HEADER_TRANSITION: (state, payload) => {
      state.$isActiveHeaderTransition = payload
    },
    SET_ACTIVE_BLOCK: (state, payload) => {
      state.$activeBlock = payload
    },
    SET_ACTIVE_WHITE_BLOCK: (state, payload) => {
      state.$activeWhiteBlock = payload
    },
    SET_BLOCK_SCROLL_GLOBAL: (state, payload) => {
      state.isBlockScroll = payload
    },
    SET_IS_HISTORY_SCREEN: (state, payload) => {
      state.$isHistoryScreen = payload
    },
  },
  actions: {
    IS_ACTIVE_MODAL: (context, payload) => {
      context.commit('SET_IS_ACTIVE_MODAL', payload)
    },
    IS_SCROLL_PARENT: (context, payload) => {
      context.commit('SET_IS_SCROLL_PARENT', payload)
    },
    IS_MOBILE: (context, payload) => {
      context.commit('SET_IS_MOBILE', payload)
    },
    ACTIVE_FIXED_HEADER: (context, payload) => {
      context.commit('SET_ACTIVE_FIXED_HEADER', payload)
    },
    ACTIVE_WHITE_BLOCK: (context, payload) => {
      context.commit('SET_ACTIVE_WHITE_BLOCK', payload)
    },
    IS_ACTIVE_HEADER_TRANSITION: (context, payload) => {
      context.commit('SET_IS_ACTIVE_HEADER_TRANSITION', payload)
    },
    ACTIVE_BLOCK: (context, payload) => {
      context.commit('SET_ACTIVE_BLOCK', payload)
    },
    BLOCK_SCROLL_GLOBAL: (context, payload) => {
      context.commit('SET_BLOCK_SCROLL_GLOBAL', payload)
    },
    IS_HISTORY_SCREEN: (context, payload) => {
      context.commit('SET_IS_HISTORY_SCREEN', payload)
    },
  },
  modules: {
    scrollModule: scrollModule
  }
})
